import { Box, Button, Typography } from "@mui/material";
import footerImage from "../../images/footer.WEBP";
import SarodiIcon from "../../images/sarodi-white.svg";

const footerMenu = [
  {
    id: 1,
    title: "ایمن آب",
    href: "https://www.imenabco.com/",
  },
  {
    id: 2,
    title: "سارودی",
    href: "https://sarodi.co/",
  },
  {
    id: 3,
    title: "تماس با ما",
    href: "https://www.imenabco.com/contact-us/",
  },
];

const FooterPage = () => {
  return (
    <Box>
      <img
        src={footerImage}
        alt="Seashore"
        style={{
          objectFit: "cover",
          position: "absolute",
          opacity: ".9",
          zIndex: "-1",
          width: "100%",
          height: "100%",
          top: "0",
          right: "0",
          bottom: "0",
          left: "0",
        }}
      />
      <Box
        sx={{
          width: { xs: "10rem", md: "20rem" },
          position: "absolute",
          top: "10%",
          left: "10%",
        }}
      >
        <img
          src={SarodiIcon}
          alt="Sarodi icon"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </Box>

      <Box
        sx={{
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "1rem",
          position: "absolute",
          bottom: "0",
          right: "10%",
        }}
      >
        <Box
          sx={{
            width: "2px",
            background: "#fff",
            height: "40dvh",
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          {footerMenu.map((item) => (
            <Box
              key={item.id}
              sx={{
                cursor: "pointer",
                marginRight: "-.25rem",
                display: "flex",
                alignItems: "center",
                gap: ".5rem",
              }}
            >
              <Box
                sx={{
                  width: "10px",
                  height: "10px",
                  background: "#fff",
                  borderRadius: "50%",
                }}
              />
              <Button
                variant="text"
                sx={{ color: { xs: "#000", md: "#fff" }, fontSize: "1.2rem" }}
                LinkComponent="a"
                href={item.href}
              >
                {item.title}
              </Button>
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            width: "2px",
            background: "#fff",
            height: "15dvh",
          }}
        />
      </Box>
    </Box>
  );
};

export default FooterPage;
